import React from 'react'
import { useState } from 'react';
import { message } from 'antd';
import { makeRequest } from '../../services/api';

const useProducts = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(12);
    const [total, setTotal] = useState(0);

    const getFoods = async (categoryId) => {
        try {
            setIsLoading(true)
            if(categoryId == null) {
                return console.warn("CategoryId is required")
            }
    
            const response = await makeRequest('get', `/dinning/web-all?page=${currentPage}&limit=${pageSize}&categoryId=${categoryId}`);
    
            if(response) {
                setTotal(response.data.totals);
                return response.data
            }
        } catch (error) {
            return message.error("Failed to fetch foods")
        } finally {
            setIsLoading(false)
        }
    }

    return {
        getFoods,
        total,
        pageSize,
        currentPage,
        isLoading,
        setCurrentPage,
        setPageSize
    }
}

export default useProducts
